import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const viteEnv = import.meta.env ?? {}

// True only when the deployment actually provides a Supabase backend.
// Unconfigured bundles (the appliance build among them) must not fabricate
// http://localhost:54321 — a shipped UI probing an arbitrary port on the
// customer's machine — so the client below gets a fetch that fails fast
// with zero network egress, and feature code can branch on this flag to
// skip Supabase-backed lanes entirely.
export const isSupabaseConfigured = Boolean(viteEnv.VITE_SUPABASE_URL)

// .invalid is an IETF-reserved TLD: even a code path that reads the URL
// string directly can never resolve it.
const supabaseUrl = viteEnv.VITE_SUPABASE_URL || 'https://supabase-unconfigured.invalid'
const supabaseAnonKey = viteEnv.VITE_SUPABASE_ANON_KEY || 'placeholder-key'

const unconfiguredFetch: typeof fetch = () =>
  Promise.reject(new Error('Supabase is not configured in this deployment.'))

export const supabase: SupabaseClient = createClient(
  supabaseUrl,
  supabaseAnonKey,
  isSupabaseConfigured ? {} : { global: { fetch: unconfiguredFetch } },
)
